import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-project-card-reprint" }
const _hoisted_2 = { class: "gfu-bt gfu-bt--b2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", null, "raised", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, _toDisplayString($options.formatedValue) + " more", 1 /* TEXT */),
    _cache[1] || (_cache[1] = _createElementVNode("div", null, "than the original", -1 /* CACHED */)),
    _cache[2] || (_cache[2] = _createElementVNode("div", null, "campaign", -1 /* CACHED */))
  ]))
}